const config = {
  contentful: {
    accessToken: 'oKnPnLrgUVk8H5JkQYwXnmRDqoHO33--BzmTxPpRcfw',
    space: '9y4fi2gkk4ov',
    environment: 'master',
  },
  nacelle: {
    accessToken: '7add5f81-7468-4617-9512-1120ffa0056d',
    endpoint:
      'https://storefront.api.nacelle.com/graphql/v1/spaces/8ae924d2-4363-4151-84a4-0c269eb56c81',
  },
  ninetailed: {
    previewPlugin: {
      clientId: '79e33a8f-9ff5-4ef2-963f-9865902d9904',
      secret: '5e0906fa-08d5-4271-9848-e3e4bfa08086',
    },
    provider: {
      clientId: '959454bc-e4e6-4088-9861-937af542b86e',
      environment: 'main',
    },
  },
  searchspring: {
    siteId: '9q03mm',
  },
  trustpilot: {
    url: 'https://de.trustpilot.com/review/ruggable.de',
    businessId: '618dae8ddb7c21ae14effb28',
  },
  defaultLocale: 'de-DE',
};

export default config;
